import React from 'react'

/** SPA navigation matching the app's hand-rolled router (App.tsx listens for
 *  the `fg_route_change` event to re-read the route mode). */
export function navigateTo(path: string): void {
  if (typeof window === 'undefined') return
  if (window.location.pathname + window.location.search === path) return
  window.history.pushState({}, '', path)
  window.dispatchEvent(new Event('fg_route_change'))
}

/** The CFO Core wordmark: gradient rounded-square + white rising-trend glyph,
 *  followed by the "CFO Core" lockup. Matches CfoPageShell. */
export function CfoBrandMark({ sub }: { sub?: string }) {
  return (
    <div className="cfo-site-brand">
      <span className="cfo-site-mark" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
          <path
            d="M4 16 9 10l3.5 3L20 5"
            style={{ stroke: '#fff', strokeWidth: 2, fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round' }}
          />
          <circle cx="20" cy="5" r="2" fill="#fff" />
        </svg>
      </span>
      <span style={{ display: 'flex', flexDirection: 'column' }}>
        <b>CFO Core</b>
        <span>{sub || 'by FuseGrid'}</span>
      </span>
    </div>
  )
}

export function CfoSiteFooter() {
  return (
    <footer className="cfo-footer">
      <div className="cfo-wrap" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
        <span>© {new Date().getFullYear()} FuseGrid · QuickBooks &amp; Xero — the full CFO suite, reconciled to the penny · Sage Accounting early access · Intacct &amp; NetSuite in development</span>
        <span>
          <a onClick={() => navigateTo('/privacy')} style={{ cursor: 'pointer' }}>Privacy</a>
          <a onClick={() => navigateTo('/terms')} style={{ cursor: 'pointer' }}>Terms</a>
        </span>
      </div>
    </footer>
  )
}
